module.exports = __webpack_public_path__ + "static/img/logo_ico.c642c92.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo_ico.svg
// module id = 174
// module chunks = 0